import { render, staticRenderFns } from "./reportDetailLow.vue?vue&type=template&id=80bf1062&"
import script from "./reportDetailLow.vue?vue&type=script&lang=js&"
export * from "./reportDetailLow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports